module.exports = __webpack_public_path__ + "img/1528781146.ad893c1b.jpg";